// extracted by mini-css-extract-plugin
module.exports = {"stars":"_3SBHoD","clickable":"_1_3Pb5","star":"_1lHTJw","number":"_35Z-16","shine-lines":"_2pLvFs"};